import React, { useState, useEffect, forwardRef, Fragment, useRef } from "react";
import {
    Container, Slide, Box, Divider, Typography, Grid, Paper, TextField, Button, Backdrop, CircularProgress
} from "@mui/material";
import MuiLink from '@mui/material/Link';
import { styled } from "@mui/material/styles";
import "../index.css";
import Breadcrumb from "../components/layout/Breadcrumb";
import { useTranslation } from 'react-i18next';

// React Router
import { useNavigate } from "react-router-dom";

const breadcrumbData = ["主頁", "會員", "成為會員"];

function BecomeMemberPage(props) {
    const { t, i18n } = useTranslation();

    return (
        <RootBox sx={{ minHeight: 'calc(100vh - 210px)' }}>
            <Root className={classes.root}>
                <Box sx={{ mt: { xs: 8.25, md: 12.5 }}}>
                    <Breadcrumb breadcrumbData={breadcrumbData} />
                </Box>
                <Box sx={{ mt: 4 }}>
                    <Typography variant="h4">{t('member.becomeMember.title')}</Typography>
                </Box>
                <CustomDivider className={'becomeMember'} />
                <Box sx={{ mt: 4.5, textDecoration: 'underline' }}>
                    <Typography variant="subtitle1">
                    {t('member.becomeMember.category.normal')}
                    </Typography>
                </Box>
                <Box sx={{ mt: 2 }}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ {t('member.becomeMember.normalMember.qualification1')}
                    </Typography>
                </Box>
                <Box sx={{ mt: 2}}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ {t('member.becomeMember.normalMember.qualification2')}
                    </Typography>
                </Box>
                <Box sx={{ mt: 2}}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ {t('member.becomeMember.normalMember.yearFee')}
                    </Typography>
                </Box>
                <Box sx={{ mt: 2}}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ {t('member.becomeMember.normalMember.oneTimeFee')}
                    </Typography>
                </Box>
                <Box sx={{ mt: 2}}>
                    <Typography variant="body1" sx={{ ml: 4, fontWeight: 'bold' }}>
                    {t('member.becomeMember.normalMember.download1')}
                        <MuiLink color="inherit" href="https://hkmeca.org/form/一般會員入會申請表.docx" target="_blank">
                            {t('member.becomeMember.normalMember.download2')}
                        </MuiLink>
                            {t('member.becomeMember.normalMember.download3')}
                        <MuiLink color="inherit" href="https://hkmeca.org/form/附頁一_相關工程經驗.docx" target="_parent" download>
                            {t('member.becomeMember.normalMember.download2')}
                        </MuiLink>
                            {t('member.becomeMember.normalMember.download4')}
                    </Typography>
                </Box>
                <Box sx={{ mt: 2, textDecoration: 'underline' }}>
                    <Typography variant="subtitle1">
                    {t('member.becomeMember.category.related')}
                    </Typography>
                </Box>
                <Box sx={{ mt: 2 }}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ {t('member.becomeMember.relatedMember.qualification1')}
                    </Typography>
                </Box>
                <Box sx={{ mt: 2}}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ {t('member.becomeMember.relatedMember.yearFee')}
                    </Typography>
                </Box>
                <Box sx={{ mt: 2, mb: 2 }}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ {t('member.becomeMember.relatedMember.oneTimeFee')}
                    </Typography>
                </Box>
                <Box sx={{ mt: 2}}>
                    <Typography variant="body1" sx={{ ml: 4, fontWeight: 'bold' }}>
                    {t('member.becomeMember.relatedMember.download1')}<MuiLink color="inherit" href="https://hkmeca.org/form/協同會員入會申請表.docx" target="_blank">{t('member.becomeMember.relatedMember.download2')}</MuiLink>{t('member.becomeMember.relatedMember.download3')}
                    </Typography>
                </Box>
                <Box sx={{ mt: 4, mb: 2}}>
                    <Typography variant="body1" sx={{ ml: 4, fontWeight: 'bold' }}>
                    {t('member.becomeMember.details.download1')}<MuiLink color="inherit" href="https://hkmeca.org/form/會員福利及入會教學.pdf" target="_blank">{t('member.becomeMember.details.download2')}</MuiLink>{t('member.becomeMember.details.download3')}
                    </Typography>
                </Box>
                <Box sx={{ mt: 2, textDecoration: 'underline' }}>
                    <Typography variant="subtitle1">
                    海外一般會員
                    </Typography>
                </Box>
                <Box sx={{ mt: 2 }}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ 海外一般會員並不包括港澳企業
                    </Typography>
                </Box>
                <Box sx={{ mt: 2}}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ 海外一般會員並不賦予投票權
                    </Typography>
                </Box>
                <Box sx={{ mt: 2}}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ 海外一般會員只供從事金屬、鋁質、玻璃或結構的加工廠選擇加入
                    </Typography>
                </Box>
                <Box sx={{ mt: 2, mb: 2 }}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ 每年會費為HK$8,000
                    </Typography>
                </Box>
                <Box sx={{ mt: 2, mb: 2 }}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ 一次性註冊費為HK$1,000
                    </Typography>
                </Box>
                <Box sx={{ mt: 2}}>
                    <Typography variant="body1" sx={{ ml: 4, fontWeight: 'bold' }}>
                    {t('member.becomeMember.relatedMember.download1')}<MuiLink color="inherit" href="https://hkmeca.org/form/海外一般會員入會申請表.docx" target="_blank">{t('member.becomeMember.relatedMember.download2')}</MuiLink>下載海外一般會員入會申請表
                    </Typography>
                </Box>
                <Box sx={{ mt: 2, textDecoration: 'underline' }}>
                    <Typography variant="subtitle1">
                    海外協同會員
                    </Typography>
                </Box>
                <Box sx={{ mt: 2 }}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ 海外協同會員並不包括港澳企業
                    </Typography>
                </Box>
                <Box sx={{ mt: 2}}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ 海外協同會員並不賦予投票權
                    </Typography>
                </Box>
                <Box sx={{ mt: 2}}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ 海外協同會員供從事金屬、鋁質、玻璃或結構的加工廠或其他行業加入
                    </Typography>
                </Box>
                <Box sx={{ mt: 2}}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ 海外協同會員只供參加部份活動及接收部份訊息
                    </Typography>
                </Box>
                <Box sx={{ mt: 2, mb: 2 }}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ 每年會費為HK$1,200
                    </Typography>
                </Box>
                <Box sx={{ mt: 2, mb: 2 }}>
                    <Typography variant="body1" sx={{ ml: 4 }}>
                    ▪️ 一次性註冊費為HK$600
                    </Typography>
                </Box>
                <Box sx={{ mt: 2}}>
                    <Typography variant="body1" sx={{ ml: 4, fontWeight: 'bold' }}>
                    {t('member.becomeMember.relatedMember.download1')}<MuiLink color="inherit" href="https://hkmeca.org/form/海外協同會員入會申請表.docx" target="_blank">{t('member.becomeMember.relatedMember.download2')}</MuiLink>下載海外協同會員入會申請表
                    </Typography>
                </Box>
            </Root>
        </RootBox>
    )
}

const PREFIX = "introdution";

const classes = {
    root: `${PREFIX}-root`,
    loading: `${PREFIX}-loading`,
};

const Root = styled(Container)(({ theme }) => ({
    [`&.${classes.root}`]: {
        // width: '100%',
        backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
        height: '100%',
        background:
            theme.palette.mode === "dark"
                ? theme.palette.background.primary
                : "#fff",
        color:
            theme.palette.mode === "dark"
                ? "#fff"
                : theme.palette.text.primary,
        divider:
            theme.palette.mode === "dark"
                ? "#fff"
                : theme.palette.text.primary,
    },
    [`&.${classes.loading}`]: {
        height: '100vh',
        background:
            theme.palette.mode === "dark"
                ? theme.palette.background.primary
                : "#fff",
        color:
            theme.palette.mode === "dark"
                ? "#fff"
                : theme.palette.text.primary,
        divider:
            theme.palette.mode === "dark"
                ? "#fff"
                : theme.palette.text.primary,
    },
}));

const RootBox = styled(Box)(({ theme }) => ({
    background: theme.palette.mode === 'dark'
        ? '#1A2027'
        : `linear-gradient(rgba(255,255,255,0.9), rgba(255,255,255,0.9)), url('img/bg.png')`,
    variant: 'outlined',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'left',
    color: theme.palette.text.primary,
}));

const Title = (props) => {
    return (
        <Box sx={{ my: 2, flexGrow: 1, display: { xs: 'flex', md: 'flex' } }}>
            <Grid container spacing={{ xs: 1, md: 2 }} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Grid item xs={12} sm={12} md={12}
                    container
                    spacing={0}
                    direction="row"
                    justifyContent={props.position ? props.position : "center"}
                >
                    <Typography
                        variant="h4"
                        component="div"
                        sx={{ fontWeight: 'bold' }}
                    >
                        {props.title}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

const SubTitle = (props) => {
    return (
        <Box sx={{ my: 2, flexGrow: 1, display: { xs: 'flex', md: 'flex' } }}>
            <Grid container spacing={{ xs: 1, md: 2 }} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Grid item xs={12} sm={12} md={12}
                    container
                    spacing={0}
                    direction="row"
                    justifyContent={props.subtitle ? props.subtitle : "center"}
                >
                    <Typography
                        variant="subtitle1"
                        component="div"
                        sx={{ fontWeight: 'bold' }}
                    >
                        {props.subtitle}
                    </Typography>
                </Grid>
            </Grid>
        </Box>
    )
}

const CustomDivider = styled(Divider)(({ theme }) => ({
    [`&.becomeMember`]: {
        background:
            theme.palette.mode === "dark"
                ? theme.palette.primary.main
                : '#7A5D26',
        borderBottomWidth: 2,
        width: "8rem"
        // marginBottom: 10
    },

}));

const ScaleCard = styled(Box)(({ theme }) => ({
    "&:hover": {
        transition: "transform 0.5s ease-in-out",
        transform: "scale3d(1.05, 1.05, 1)"
    },
}));

export default BecomeMemberPage;